import { ClassData } from '@models/class-data';
import { SocialMediaType } from '@models/social-media/enums/social-media-type.enum';

export class SocialMediaLink {
  id: number;
  socialMediaId: number;
  type: SocialMediaType;
  link: string;
  customLabel: string;
  order: number;

  constructor(json: ClassData<SocialMediaLink>) {
    this.id = +json.id;
    this.socialMediaId = +json.socialMediaId;
    this.type = json.type;
    this.link = json.link;
    this.customLabel = json.customLabel;
    this.order = +json.order;
  }

  getControlName(): string {
    switch (this.type) {
      case SocialMediaType.INSTAGRAM:
        return 'instagramLink';
      case SocialMediaType.FACEBOOK:
        return 'facebookLink';
      case SocialMediaType.TIKTOK:
        return 'tikTokLink';
      case SocialMediaType.YOUTUBE:
        return 'youTubeLink';
      case SocialMediaType.LINKEDIN:
        return 'linkedInLink';
      case SocialMediaType.WHATSAPP:
        return 'whatsAppLink';
      case SocialMediaType.VIBER:
        return 'viberLink';
      case SocialMediaType.TELEGRAM:
        return 'telegramLink';
      case SocialMediaType.CUSTOM:
        return 'customLink';
      default:
        return '';
    }
  }
}
